import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import { filterProds, buildCtaUrl } from "../helpers";
import Product from "./Product/Product";
import RichText from "src/client/js/view/components/Prismic/RichText";

import "./Bundle.scss";

const getProducts = (filteredProds, ctaText, customisations) => {
  return filteredProds.map((product, idx) => (
    <Product
      key={idx}
      product={product.productInformation}
      ctaHref={buildCtaUrl(
        product.productInformation.productSlug,
        customisations,
        product.linkToProduct
      )}
      ctaText={ctaText}
    />
  ));
};

const Bundle = (props) => {
  const filteredProds = filterProds(
    props.bundle.products,
    props.excludeProducts
  );

  return (
    <section className="Bundle">
      <header className="Bundle__header">
        <RichText
          className="Bundle__title"
          fields={[
            {
              type: "heading2",
              text: props.bundle.title,
            },
          ]}
        />
        <p className="Bundle__description">{props.bundle.description}</p>
      </header>
      {!isEmpty(filteredProds) && (
        <div className="Bundle__products">
          {getProducts(
            filteredProds,
            props.bundle.bundleCtasText,
            props.bundle.customisations
          )}
        </div>
      )}
    </section>
  );
};

Bundle.propTypes = {
  bundle: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    bundleCtasText: PropTypes.string,
    customisations: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
  }),
  excludeProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
};

export default Bundle;
